import React, { useEffect, useState, useRef, useContext } from "react";
import clsx from "clsx";
import styled from "styled-components";
import scrollIntoView from "scroll-into-view";
import { WrapperContext } from "../Layout";

const Content = styled.div`
  flex-shrink: 0;
  position: relative;
  height: 100vh;
  width: 0 !important;
  overflow: hidden;
  // opacity: 0;
  transition: width 0.4s ease-in-out, opacity 0.4s ease-in-out;
  transition-timing-function: cubic-bezier(0.37, 0.01, 0, 0.98);
  &.reveal {
    opacity: 1;
    width: var(--col-6-13) !important;
  }
  & > section {
    position: absolute;
    height: 100%;
  }
  @media all and (max-width: 1080px) {
    width: 100vw !important;
    height: 0;
    &.reveal {
      height: auto;
      opacity: 1;
      width: 100vw !important;
    }
    & > section {
      position: absolute;
      width: 100vw !important;
      height: 100%;
    }
  }
`;

const TiroirProduct = ({ input, card, content, open = false }) => {
  const { isMobile } = useContext(WrapperContext);
  const cardRef = useRef();
  const contentRef = useRef();
  const [reveal, setReveal] = useState(open);
  const [loadContent, setLoadContent] = useState(true);
  const [baseLocation, setBaseLocation] = useState();

  const { title, slug, color } = input;

  useEffect(() => {
    setBaseLocation({
      url: window.location.href,
      title: document.title
    });
    setLoadContent(true); //load content after dom ready > prevent duplicate content
  }, []);

  useEffect(() => {
    // console.log(link);
    //scroll x intoview
    // console.log(baseLocation);
    if (baseLocation) {
      if (reveal) {
        const rootUrl = window.location.origin;
        const url = `${rootUrl}/product/${slug.current}`;
        // console.log(url);
        window.history.pushState({}, title, url);

        const target = isMobile ? contentRef.current : cardRef.current;
        const topOffset = isMobile ? 25 : 0;
        // console.log(topOffset);
        scrollIntoView(target, {
          time: 500,
          align: {
            left: 0,
            top: 0,
            topOffset: topOffset
          }
        });
      } else {
        //popState
        window.history.pushState({}, baseLocation.title, baseLocation.url);
      }
    }
  }, [reveal, baseLocation, isMobile, title, slug]);

  return (
    <>
      <section
        className='tiroir section'
        ref={cardRef}
        style={{
          backgroundColor: color ? color : "transparent"
        }}>
        <div
          className='card h-full'
          onKeyPress={() => setReveal(!reveal)}
          onClick={() => setReveal(!reveal)}
          tabIndex='0'
          role='button'>
          {card}

          <figcaption className='absolute left-0 bottom-0 p-md w-full text-sm-lg md:text-lg transition-opacity cursor-pointer'>
            {title}
          </figcaption>
        </div>
      </section>
      {loadContent && (
        <Content
          ref={contentRef}
          className={clsx(
            "content section sub-section",
            reveal ? "reveal" : ""
          )}
          style={{
            backgroundColor: color ? color : "transparent"
          }}>
          {content}
        </Content>
      )}
    </>
  );
};

export default TiroirProduct;
